import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  margin-top: 8px;
  margin-bottom: 32px;
`;
export const Top = styled.div `
  display: grid;

  gap: 24px;
  grid-auto-flow: column;
  justify-content: space-between;
`;
export const HeadingContainer = styled.div `
  margin-bottom: 4px;
  line-height: 1.2;

  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
export const Description = styled.div `
  margin-bottom: 6px;

  color: ${Colors.GS600};
  line-height: 1.5;

  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
